// extracted by mini-css-extract-plugin
module.exports = {"bb-simple-text-form":"bb-simple-text-form__lng9P"};